<template>
	<div class="button-group">
		<button
			v-for="button in buttons"
			:data-cy="`tip-option-${button.name}`"
			v-bind:class="{
				selected: selectedButton && selectedButton.value == button.value
			}"
			:key="button.value"
			@click="onButtonClicked(button)"
		>
			{{ button.name }}
		</button>
	</div>
</template>

<style scoped>
.button-group {
	width: 100%;
	display: flex;
	border: 1px solid var(--gR-base-90);
	border-radius: 5px;
	overflow: hidden;
	height: 35px;
	font-size: 12px;
}

.button-group button {
	flex: 1;
	background: var(--gR-white);
	border-right: 1px solid var(--gR-base-90);
}

.button-group button:last-child {
	border-right: none;
}

.button-group button.selected {
	background: var(--gR-base-90);
	color: var(--gR-white);
	font-weight: 700;
}
</style>

<script>
export default {
	name: "SkButtonGroup",
	props: {
		buttons: Array
	},
	data: function () {
		return {
			selectedButton: null
		}
	},
	mounted: function () {
		this.setSelectedButton()
	},
	methods: {
		onButtonClicked(selectedButton) {
			this.selectedButton = selectedButton
			this.$emit("buttonSelected", selectedButton)
		},
		setSelectedButton() {
			const selectedButton = this.buttons.find(
				(button) => button.is_selected
			)
			if (
				(selectedButton && !this.selectedButton) ||
				selectedButton != this.selectedButton
			) {
				this.selectedButton = selectedButton
			}
		}
	},
	watch: {
		buttons() {
			this.setSelectedButton()
		}
	}
}
</script>